import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class SubletBus extends BaseBus{
    constructor(busObj: SubletBus) {
        super(busObj);

    }
    CID(): any {
        return this.subletId;
    }
    setId(id: any) {
        this.subletId = id;
    }
    initialize(data: SubletBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setParentId(id: any) {
        this.bidDetailID = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: SubletBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    subletId:string;
    bidDetailID:string;
    subletTypeId:string;
    stRate:number;
    stHours:number;
    otRate:number;
    otHours:number;
    labTotal:number;
    matTotal:number;
    subContractorName:string;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    subletTypeDesc:string;
    stTotal:number;
    otTotal:number;
    lab_Mat_Total:number;
    sortOrder  : number;
    specialtySubletId: string;
    specialtySubletName: string;
    subletTypeName: string;
    public dragging: boolean;
}
export enum Sublet {
    SubletOther = 'SUBLET OTHER',
    InHouseGcTotal = 'IN-HOUSE GC TOTAL'
}
